import React from "react";
import { ConnectedRouter } from "react-router-redux";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import ErrorBoundary from "./ErrorBoundary";
import { libraries } from "./constants/constants";
import CircularProgress from "./components/CircularProgress";


export const store = configureStore();

class NextApp extends React.Component {

  constructor(props){
    super(props);
    this.state ={
      appLoading: true
    }
  }

  errorHandler = async (error, stackTrace) => {
    // send error logs to developer team
  };

  componentDidMount() {
    this.loadScripts();
  }

  loadScripts = function () {
    const baseUrl = window.location.origin;
    let promises = [];
    libraries.forEach((lib, index) => {
      const libPath = baseUrl +"/" + lib;
      console.log('append script:', libPath);
      const promise = new Promise((resolve, reject) => {
        resolve(this.appendScript(libPath, index));
      });
      promises.push(promise);
    });
    Promise.all(promises).then((values) => {
       setTimeout(() => {
        this.setState({
          appLoading: false
         });
       }, 5000);
    });
  }

  appendScript = (src, file_id) => {
    const scriptexist = document.getElementById(file_id);
    if (!scriptexist) {
      const tag = document.createElement('script');
      tag.type = "text/javascript";
      tag.async = false;
      tag.src = src;
      tag.id = file_id;
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(tag);
    }
    return true;
  }

  render() {
    const { appLoading } = this.state;
    if (appLoading) {
      return <CircularProgress />
    }
    return (
      <ErrorBoundary onError={this.errorHandler}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Switch>
              <Route path="/" component={App} />
            </Switch>
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default NextApp;
